<template>
    <v-form>
        <v-container
            v-if="form"
            fluid
            class="px-4">

            <v-row>
                <slot name="content" v-bind:form="form"/>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
export default {
    name: 'DetailForm',

    props: {
        value: {
            type: Object,
            default: () => null
        }
    },

    computed: {
        form: {
            get () {
                return this.value
            },

            set (value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
